'use strict';

/*
  For now, add simple handlers needed for desktop local
  TODO: convert to Preact code
*/
const { windowLoaded } = require('@grpn/document-states');

const { addCartHandler } = require('./cart');
const {
  addEventPipe,
  addBuyButtonClickHandler,
  addOptionsClickHandler,
} = require('./event_handlers');
const removeUrgencyPricing = require('../util/remove_urgency_pricing');

const BuyButtonForm = {
  syncOptions({ isInline, isOverlay, $option }) {
    const $modal = document.querySelector('#options');

    if (!$modal) {
      return;
    }

    if (isInline) {
      $modal.querySelector(
        `.multi-option-overlay-list input[data-uuid='${$option.dataset.uuid}']`
      ).checked = true;
    } else if (isOverlay) {
      const $inlineOption = document.querySelector(
        `.multi-option-breakout.inline-list input[data-uuid='${
          $option.dataset.uuid
        }']`
      );
      $inlineOption.checked = true;

      const $inlineListElement = $inlineOption.parentNode.parentNode;
      if ($inlineListElement.classList.contains('hide')) {
        const $inlineList = $inlineListElement.parentNode;
        $inlineList.insertAdjacentElement('afterbegin', $inlineListElement);
        [...$inlineList.querySelectorAll('li')]
          .filter(el => !el.classList.contains('hide'))
          .pop()
          .classList.add('hide');
        $inlineListElement.classList.remove('hide');
      }
    }
  },

  showProcessingLoader({ target }) {
    target.classList.add('loading');

    // need to allow the form to submit first
    window.requestAnimationFrame(() => target.setAttribute('disabled', true));
  },

  setupBuyButtonClickHandler() {
    addBuyButtonClickHandler.call(this, this.showProcessingLoader.bind(this));
    this.$buyButton = document.querySelector('.buy-button .buy');
  },

  updateGiftButton({ $option }) {
    const url = document.querySelector(
      `.multi-option-breakout input[data-uuid='${$option.dataset.uuid}']`
    ).value;

    document.querySelectorAll('.gift-button').forEach($btn => {
      $btn.href = `${url}&gift=true`;
    });
  },

  setupOptionsClickHandler() {
    addOptionsClickHandler.call(this, data => {
      this.syncOptions(data);
      this.updateGiftButton(data);
    });
    const $overlayList = document.querySelector('.multi-option-overlay-list');
    if ($overlayList) {
      $overlayList.addEventListener('click', event => {
        if (event.target.nodeName.toLowerCase() === 'input') {
          this.eventPipe.trigger('option_clicked', {
            $option: event.target,
            isOverlay: true,
          });
        }
      });
    }
  },

  addScrollOverlayListener() {
    const $overlay = document.querySelector('#options .scroll-fade-overlay');
    if ($overlay) {
      const observer = new window.IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.75) {
              $overlay.style.display = 'none';
            } else {
              $overlay.style.display = 'block';
            }
          });
        },
        {
          threshold: 0.75,
        }
      );

      observer.observe(
        [
          ...document.querySelectorAll('.multi-option-breakout.option-list li'),
        ].pop()
      );
    }
  },

  addModalHandlers() {
    const $openModalButton = document.querySelector('#view-options a');
    if ($openModalButton) {
      $openModalButton.addEventListener('click', () => {
        this.addScrollOverlayListener();
      });

      window.DealEventPipe.on('juice_price_ended', () => {
        removeUrgencyPricing(this.data);
      });

      if (this.data.hasModal) {
        windowLoaded.then(() =>
          import(
            /* webpackChunkName: "modal_cluster" */ './modal_cluster'
          ).then(modalCluster => {
            if (
              document
                .querySelector('#options')
                .classList.contains('show-modal')
            ) {
              modalCluster.init(this.data);
            } else {
              $openModalButton.addEventListener(
                'click',
                () => {
                  modalCluster.init(this.data);
                },
                {
                  once: true,
                }
              );
            }
          })
        );
      }
    }
  },

  // "form" attribute used on buy button does not work in ie11
  replaceSubmitScript() {
    /*
      would be better to align cart functionality with this code.
      for now, just bail on this behavior since we know cart
      code is supposed to handle proceed-to-checkout
    */
    if (!this.data.submitFnName || this.data.hasCart) {
      return;
    }

    // unset previous functionality
    window[this.data.submitFnName] = undefined;
    document.querySelectorAll('form.multi-option-breakout').forEach(formEl => {
      formEl.setAttribute('onsubmit', 'return false;');
    });
    const inlineSubmitScript = document.querySelector('#buy-submit-script');
    if (inlineSubmitScript) {
      inlineSubmitScript.parentNode.removeChild(inlineSubmitScript);
    }

    // add buy button submission to event pipe
    this.eventPipe.on('buy_button_clicked', () => {
      const newHref = document.querySelector(
        '.multi-option-breakout.inline-list input:checked'
      ).value;
      window.location = newHref;
      return false;
    });
  },

  init({ buyButtonForm = {}, cart }, done) {
    this.data = buyButtonForm;
    this.data.hasCart = !!cart;
    addEventPipe.call(this);

    this.setupBuyButtonClickHandler();
    this.setupOptionsClickHandler();

    addCartHandler.call(this, cart);

    this.addModalHandlers();

    this.replaceSubmitScript();

    return done();
  },
};

module.exports = BuyButtonForm;
